import { Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import { createBrowserHistory } from "history";
import Loading from "pages/Loading/Loading";
import Layout from "layout/Layout";
import Homepage from "pages/Homepage/Homepage";
import Page404 from "pages/page404/Page404";
import Application from "pages/Application/Application";

const browserHistory = createBrowserHistory();

const RouterList = () => {

  return (
    <Router>
      <Suspense fallback={<Loading />}>
        <Routes>
          {/* <Route
            path="/login"
            element={<Login />}
          /> */}
          <Route path="*" element={<Page404 />} />
          <Route element={<Layout />}>
            <Route
              path="/"
              element={<Homepage />}
            />
            <Route
              path="/uygulama"
              element={<Application />}
            />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
};
export default RouterList;
